export const HeaderData = [
    {url: "/", text: "Home"},
    {
        url: "/cfp",
        text: "CFP",
        dropDown: [
            {
                text: "Submission Guidelines",
                url: "/cfp/#guidelines",
            },

            {
                text: "Key Dates",
                url: "/cfp/#dates",
            },
        ]
    },
    {url: "/accepted-papers", text: "Accepted Papers"},

    {
        url: "/program-2025",
        text: "Workshop Program",
    },
    {
        url: "/team", text: "Team",
        dropDown: [
            {
                text: "Organizers",
                url: "/team/#organizers",
            },
            {
                text: "PC",
                url: "/team/#pc",
            },
        ]
    },
];